import { Component } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
    KvI18nService,
    GlobalLoggerMonitor,
    GlobalLoggerMonitorConfig,
} from '@kv-common-components/kv-common-components';
import {
    AuthenticationService,
    EspaceClientService,
    User,
    DiagnosticService,
    ReferentielService,
} from '@kv-common-components/kx-services';

import { environment } from './../environments/environment';
import { Router } from '@angular/router';
import { PersonneHelperService } from '@shared/services/personne-helper.service';
import { forkJoin } from 'rxjs';
import { RouterHelperService } from '@shared/services/router-helper.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    i18nData: any;
    appLoading: boolean;
    pushedRight = false;
    pushedLeft = false;
    noScrollDocument = false;

    constructor(
        private kvI18nService: KvI18nService,
        private logger: NGXLogger,
        private authenticationService: AuthenticationService,
        private espaceClientService: EspaceClientService,
        private router: Router,
        private personneHelper: PersonneHelperService,
        private referentielService: ReferentielService,
        private routerHelper: RouterHelperService,
        diagnosticService: DiagnosticService,
        deviceDetectorService: DeviceDetectorService
    ) {
        this.appLoading = true;

        const loggerConfig = environment.loggerConfig;
        const loggerMonitorConfig: GlobalLoggerMonitorConfig = {
            diagnosticLoggingServerLevel:
                loggerConfig.diagnosticLoggingServerLevel,
            diagnosticLoggingMissingKeyI18n:
                loggerConfig.diagnosticLoggingMissingKeyI18n,
            diagnosticLoggingErrorCallWebserviceI18n:
                loggerConfig.diagnosticLoggingErrorCallWebserviceI18n,
            diagnosticLoggingException: loggerConfig.diagnosticLoggingException,
            website: environment.websiteName,
        };
        // Registered NGXLogger Monitor as soon as possible so that it does not miss any logs message.
        this.logger.registerMonitor(
            new GlobalLoggerMonitor(
                authenticationService,
                deviceDetectorService,
                diagnosticService,
                logger,
                loggerMonitorConfig
            )
        );

        //This command is for TagCommander this.initTagCommander();
        this.kvI18nService.refreshI18n();
        this.kvI18nService.i18nData.subscribe((data) => {
            this.i18nData = data;
        });
        this.logger.trace('Client connexion with environment config : ', {
            environment,
        });
        //Not activation and not reinitialisation
        if (window.location.href.includes('/connexion/otp')) {
            this.logger.debug('refresh on /connexion/otp');
            const user = this.authenticationService.currentUserValue;
            if (user && this.tokenIsValid(user)) {
                this.logger.debug('user exist and token is valid');
                this.appLoading = false;
            } else {
                this.resetAppToLogin(true);
            }
        } else if (
            !window.location.href.includes('/activation') &&
            !window.location.href.includes('/reinitialisation') &&
            !window.location.href.includes('/connexion')
        ) {
            let user = this.authenticationService.currentUserValue;
            if (environment.ihmLaunchParams) {
                this.authenticationService
                    .postSouscriptionPartenaire(environment.ihmLaunchParams)
                    .subscribe(() => {
                        user = this.authenticationService.currentUserValue;
                        this.initappAfterLogin(user);
                    });
            } else if (user && this.tokenIsValid(user)) {
                this.initappAfterLogin(user);
            } else if (window.location.href.includes('/bsc')) {
                this.logger.info('Bascule mobile');
                this.appLoading = false;
            } else {
                this.resetAppToLogin(true);
            }
        } else {
            this.resetAppToLogin();
        }
    }
    readLocalStorageValue(key) {
        return localStorage.getItem(key);
    }
    toggleNoScrollMobile() {
        const elements = document.getElementsByTagName('html');
        elements[0].className =
            this.pushedLeft || this.pushedRight ? 'no-scroll' : '';
    }
    toggleNoScroll() {
        const elements = document.getElementsByTagName('html');
        this.noScrollDocument = !this.noScrollDocument;
        elements[0].className = this.noScrollDocument ? 'no-scroll' : '';
    }

    private resetAppToLogin(withredirect?: boolean) {
        this.authenticationService.logout(true);
        this.appLoading = false;
        if (withredirect) {
            this.router.navigateByUrl('/connexion');
        } else {
            this.routerHelper.navigationChange({ url: 'connexion' });
        }
    }

    // returns true the token is still valid and false if the token has expired
    private tokenIsValid(user: User): boolean {
        return Date.now() < user.expirationDate;
    }

    private initappAfterLogin(user: User) {
        forkJoin({
            analyses: this.referentielService.getAnalysesMedicales(),
            maladies: this.referentielService.getMaladies(),
            medicaments: this.referentielService.getMedicaments(),
        }).subscribe(() => {
            this.espaceClientService
                .refreshEspaceClient(user.idPersonne)
                .subscribe((data) => {
                    this.personneHelper.initCurrentUser(data, user);
                    this.appLoading = false;
                });
        });
    }
}
